import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { getIconForChannel } from 'svh-workspace-ui-lib/preview-card/public/operators';
import { PreviewCardCheckbox, previewCardTheme } from './PreviewCardStyles';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { DatabasesIcon, MessagesIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisabledCircle = styled.div.withConfig({
  displayName: "PreviewCardChannelIcon__DisabledCircle",
  componentId: "sc-1hqp58u-0"
})(["background:", " !important;width:", "px;height:", "px;min-width:", "px;border-radius:50%;"], ({
  theme
}) => theme.color['border-tertiary-default'], previewCardTheme.AVATAR_SIZE, previewCardTheme.AVATAR_SIZE, previewCardTheme.AVATAR_SIZE);
const getBackgroundColorMap = ({
  isUnread,
  isSelected
}) => {
  if (isSelected) {
    return 'fill-info-default';
  }
  if (isUnread) {
    return 'fill-accent-neutral-default';
  } else {
    return 'icon-primary-disabled';
  }
};
const getChannelIconByFallbackIcon = (fallbackIcon, channelId) => fallbackIcon === 'databases' ? getIconForChannel(channelId, DatabasesIcon) : getIconForChannel(channelId);
const getFallbackIcon = fallbackIcon => {
  if (fallbackIcon === 'databases') {
    return DatabasesIcon;
  }
  return MessagesIcon;
};
const ChannelIcon = ({
  isInBatchUpdatesList,
  disabled,
  channelId,
  isUnread,
  isSelected,
  fallbackIcon
}) => {
  // @bend-expect trellis-tokenized
  if (disabled) return /*#__PURE__*/_jsx(DisabledCircle, {});
  const channelIcon = channelId ? getChannelIconByFallbackIcon(fallbackIcon, channelId) : getFallbackIcon(fallbackIcon);
  return /*#__PURE__*/_jsx(IconCircle, {
    display: isInBatchUpdatesList ? 'none !important' : undefined,
    size: "400",
    icon: channelIcon,
    padding: "100",
    color: "fill-surface-default",
    backgroundColor: getBackgroundColorMap({
      isUnread,
      isSelected
    }),
    borderWidth: "0",
    "data-test-id": "preview-card-channel-icon",
    id: "preview-card-channel-icon"
  });
};
ChannelIcon.displayName = 'ChannelIcon';
export const PreviewCardChannelIcon = ({
  disableBulkSelect,
  disabled,
  onSelect,
  isBulkSelected,
  fallbackIcon,
  channelId,
  isUnread,
  isSelected,
  disableBulkSelectTooltip = false,
  hideBulkSelectCheckbox
}) => {
  const handleCheckboxClick = event => {
    event.stopPropagation();
    event.preventDefault();
    onSelect();
  };
  const disableTooltip = !disableBulkSelect || disableBulkSelect && isBulkSelected || disableBulkSelectTooltip;
  return /*#__PURE__*/_jsxs("div", {
    children: [!hideBulkSelectCheckbox && /*#__PURE__*/_jsx(Tooltip, {
      disabled: disableTooltip,
      maxInlineSize: "275px",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.preview-card.channel-icon-checkbox.tooltip"
      }),
      "data-test-id": "selection-limit-reached-tooltip",
      children: /*#__PURE__*/_jsx(PreviewCardCheckbox, {
        "aria-label": I18n.text('conversations-inbox-ui.preview-card.channel-icon-checkbox.selectConversation'),
        "data-test-id": "bulk-select-checkbox",
        onClick: handleCheckboxClick,
        checked: isBulkSelected,
        disabled: disableBulkSelect && !isBulkSelected
      })
    }), !isBulkSelected && /*#__PURE__*/_jsx(ChannelIcon, {
      disabled: disabled,
      channelId: channelId,
      isUnread: isUnread,
      isSelected: isSelected,
      isInBatchUpdatesList: isBulkSelected,
      fallbackIcon: fallbackIcon
    })]
  });
};
PreviewCardChannelIcon.displayName = 'PreviewCardChannelIcon';
export default PreviewCardChannelIcon;